<script>
import UserDetail from '../user/UserDetail.vue'
export default {
  name: 'CRMEditInformation',
  components: {
    UserDetail,
  },
}
</script>

<template>
  <div>
    <UserDetail :isUserDetail="false" />
  </div>
</template>

<style scoped lang="scss">
.crmHeader {
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(18, 38, 63, 0.0196078);
  border-radius: 5px;
}
::v-deep .nav-tabs {
  background-color: white;
  border-radius: 5px;
  margin-top: 20px;
}
</style>
